export default __webpack_public_path__ + "static/media/breakfast-overlay-lyte@3x.79d0de93.png";